import { Component } from '@grafikr/components';

export default Component((node) => {
  const valid = document.referrer !== '' && document.referrer !== window.location.href;

  const goBack = (event: MouseEvent) => {
    event.preventDefault();

    if (!valid) return;

    window.history.back();
  };

  node.hidden = !valid;
  node.addEventListener('click', goBack);
});
